module.exports = __webpack_public_path__ + "img/thumbnail-cedrow-with-tab.5046c9cf.webp";